<template>
  <div class="goods-top">
    <img v-if="subType == 11" src="../../assets/img/detail/top_11.png" />
    <img v-else-if="subType == 12" src="../../assets/img/detail/top_12.png" />
    <img v-else-if="subType == 21" src="../../assets/img/detail/top_21.png" />
    <img v-else-if="subType == 22" src="../../assets/img/detail/top_22.png" />
    <img v-else-if="subType == 23" src="../../assets/img/detail/top_23.png" />
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  export default {
    props: ['goodsId'],
    computed: {
      ...mapGetters(['goodsInfo']),
      goods() {
        return this.goodsInfo(this.goodsId)
      },
      subType() {
        return this.goods ? this.goods.subType : 0
      }
    }
  };

</script>
